module.exports = __webpack_public_path__ + "img/register6.e609af76.png";